export enum EditOptionsEnum {
  CLEAR = 'MESSAGE.ACTION.clear',
  OVERWRITE = 'MESSAGE.ACTION.overwrite',
  PREFIX = 'MESSAGE.ACTION.prefix',
  POSTFIX = 'MESSAGE.ACTION.postfix',
}
